import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({ baseURL: API_URL });

// Attach JWT token + inject companyId into every request body
// Mirrors the PWA HttpConfigInterceptor pattern
api.interceptors.request.use(config => {
  // JWT bearer token
  const token = localStorage.getItem('token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;

  // Inject companyId into the body only for requests that actually have a body
  // (POST / PUT / PATCH). Adding a body to GET/DELETE turns them into non-simple
  // requests and triggers a CORS preflight that breaks the request.
  // The branding bootstrap call (/company/branding) is excluded — it IS the call
  // that resolves companyId and must not require it.
  const companyId = localStorage.getItem('companyId');
  const url    = config.url || '';
  const method = (config.method || 'get').toLowerCase();
  const bodyMethods = ['post', 'put', 'patch'];
  if (companyId && bodyMethods.includes(method) && !url.includes('/company/branding')) {
    const cid = parseInt(companyId, 10);
    // FormData must not be spread into a plain object — that drops the file (e.g. bulk CSV).
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      if (!config.data.has('company_id')) {
        config.data.append('company_id', String(cid));
      }
    } else {
      config.data = { ...(config.data || {}), company_id: cid };
    }
  }

  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default api;
